import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const ParametricScrew = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();

  const [folderName, setFolderName] = useState("default");
  const [screwUrl, setScrewUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    length: "",
    major_d: "",
    pitch: "",
    head: "hex",
    drive: "none",
  });

  // Redirect if not signed in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject model-viewer script only once
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Generate Screw STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/screwdesign", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          length: parseFloat(inputs.length),
          major_d: parseFloat(inputs.major_d),
          pitch: parseFloat(inputs.pitch),
          head: inputs.head,
          drive: inputs.drive,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setScrewUrl(data.screwurl || "");
        alert("Screw design generated successfully!");
      } else {
        console.error("Error sending screw data");
        alert("Failed to generate screw.");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP ? GLB and display
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/ScrewtoGlb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting to GLB");
        alert("Error converting STEP to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="screw-container">
      <center>
        <h2 className="center-heading">Parametric Screw Generator</h2>
      </center>

      <p>Signed in as: {userEmail}</p>

      <form onSubmit={handleSubmit}>
        <input
          type="number"
          name="length"
          value={inputs.length}
          onChange={handleChange}
          placeholder="Length (mm)"
          required
        />
        <br /><br />

        <input
          type="number"
          name="major_d"
          value={inputs.major_d}
          onChange={handleChange}
          placeholder="Major Diameter (mm)"
          required
        />
        <br /><br />

        <input
          type="number"
          name="pitch"
          value={inputs.pitch}
          onChange={handleChange}
          placeholder="Thread Pitch (mm)"
          required
        />
        <br /><br />

        <select name="head" value={inputs.head} onChange={handleChange}>
          <option value="hex">Hex</option>
          <option value="socket_cap">Socket Cap</option>
          <option value="pan">Pan</option>
          <option value="button">Button</option>
          <option value="countersunk">Countersunk</option>
        </select>
        <br /><br />

        <select name="drive" value={inputs.drive} onChange={handleChange}>
          <option value="none">None</option>
          <option value="slot">Slot</option>
          <option value="phillips">Phillips</option>
          <option value="hex_socket">Hex Socket</option>
        </select>
        <br /><br />

        <button type="submit">Generate</button>
      </form>

      <br />
      <p>Screw File Path: {screwUrl}</p>

      {screwUrl && (
        <>
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            View
          </button>
          <br /><br />
          <a href={screwUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>
              Download STEP
            </button>
          </a>
        </>
      )}

      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Screw Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Screw model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{
              width: "600px",
              height: "400px",
              backgroundColor: "#e0e0e0",
            }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/main")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          � 2025 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default ParametricScrew;
